import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index.js';
import Login from '@/pages/Login.vue';
import managePagesData from './manage.js';
import registerPagesData from './register.js';
import operationPagesData from './operation.js';
import events from './event';
import product from './product';
import slackData from './slack';
import cast from '@/router/cast';
import review from './review.js';
import preferences from './preferences.js';
import brand from './brand.js';
import qna from './qna.js';
import intranet from './intranet.js';
import pageAccessRight from '@/router/pageAccessRight';
import advertisement from './advertisement.js';
import Main from '@/pages/Index.vue';

const setParentName = (obj, parentName) => {
	for (let key in obj) {
		if (!obj[key].parentName) {
			obj[key].parentName = parentName;
		}
	}
	return obj;
};

const pagesData = {
	Login: {
		id: 'Login',
		title: '글로우픽',
		heading: null,
		path: '/login',
		component: Login,
	},
	Home: {
		type: 'v3',
		id: 'Home',
		title: '메인',
		heading: null,
		path: '/',
		component: Main,
	},
	...managePagesData,
	...registerPagesData,
	...setParentName(operationPagesData, '운영 관리'),
	...events,
	...product,
	...slackData,
	...setParentName(review, '리뷰 관리'),
	...cast,
	...preferences,
	...setParentName(brand, '브랜드/판매처 관리'),
	...qna,
	...advertisement,
	...intranet,
};
const pagesObj = {};
const routes = Object.keys(pagesData).reduce((acc, key) => {
	const page = pagesData[key];
	const route = {
		path: page.path,
		name: page.id,
		component: page.component,
	};
	pagesObj[page.id] = page.path;
	acc.push(route);
	return acc;
}, []);

Vue.use(Router);

const router = new Router({
	mode: 'history',
	routes,
	scrollBehavior: () => ({ x: 0, y: 0 }),
});

router.onReady(() => {
	store.commit('paths', pagesObj);
});

router.beforeEach(async (to, from, next) => {
	try {
		if (
			to.name !== 'Login' &&
			!store.state.login.idRegister &&
			!(await store.dispatch('login/tokenVerify'))
		) {
			throw 'login';
		}

		const name = to.name;
		const pageData = pagesData[name] || {};
		document.title = pageData.title;
		to.params.id = pageData.id;
		store.commit('hasHeaderTitle', !!pageData.hasHeaderTitle);
		to.params.heading = pageData.heading;
		to.params.parentName = pageData.parentName;
		to.params.type = pageData.type;

		if (!store.state.nav && to.name !== 'Login') {
			store.commit('initNav');
			await store.dispatch('initFilter');
		}
		if (to.name === 'Login') {
			store.dispatch('login/logout', true);
		}
		pageAccessRight(to, pagesData);
		next();
	} catch (err) {
		console.error(err);
		if (err === 'login') {
			store.dispatch('login/logout', true);
			next({ name: 'Login', params: { next: to.fullPath } });
		}
	}
});

export default router;
